export default function initNumberInputs(page) {
  page.querySelectorAll('.estimation-form__number-trigger').forEach(trigger => {
    const input = trigger.parentElement.querySelector('input')
    let step = Number(input.getAttribute('step'))
    if (Number.isNaN(step)) {
      step = 1
    }

    input.addEventListener('input', () => {
      const number = Number(input.value)
      if (Number.isNaN(number)) {
        input.value = ''
      } else {
        if (number > input.max) {
          input.value = input.max
        }
        if (number < input.min) {
          input.value = input.min
        }
      }

      if (step === 1) {
        input.value = Math.round(input.value)
      }
    })

    trigger.addEventListener('click', e => {
      e.preventDefault()

      if (trigger.classList.contains('plus')) {
        input.value = parseFloat(input.value) + step
      } else if (input.value > 1) {
        input.value = parseFloat(input.value) - step
      }
    })
  })
}
